var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-vat',_vm._b({attrs:{"hide-details":"auto"},model:{value:(_vm.vat),callback:function ($$v) {_vm.vat=$$v},expression:"vat"}},'select-vat',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }